import { ChartDataModel } from ".";

export class TotalChartDataModel{
    public total: number;
    public chartData: ChartDataModel[];
}